import type * as React from 'react';
import { sameOriginPath } from './sameOriginPath.ts';

/*
 * A link to one of our own pages, taken without throwing the page it was read
 * on away. One handler on the whole conversation rather than a prop on every
 * kind of message: a link can turn up in a reply, in a card, in a summary, and
 * they all end up as an anchor in here.
 *
 * Only a plain left click. Middle-clicking or holding a modifier is the reader
 * asking for a tab of their own, and they get one.
 */
export function followInApp(
  event: React.MouseEvent<HTMLElement>,
  onNavigate: (path: string) => void,
): void {
  if (event.defaultPrevented || event.button !== 0) {
    return;
  }

  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
    return;
  }

  const anchor = event.target instanceof Element ? event.target.closest('a') : null;

  if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) {
    return;
  }

  const path = sameOriginPath(anchor.getAttribute('href'));

  if (path === null) {
    return;
  }

  event.preventDefault();
  onNavigate(path);
}
